// Style
import './style.scss'

const Button = ({
  onClick,
  title,
  variation,
  className
}) => {
  return (
    <button
      onClick={onClick}
      className={`
        ${className ? className : ''} 
        ${variation === 'secondary' ? 'secondary' : 'primary'} 
        button
      `}
    >
      {title}
    </button>
  )
}

export default Button
